import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TelemetryMapComponent } from './telemetry-map/telemetry-map.component';
import { TelemetryDashboardComponent } from './telemetry-view/telemetry-dashboard.component';
import { TelemetryRealtimeComponent } from './telemetry-view/telemetry-realtime.component';
import { SseService } from 'src/app/service/sse.service';
import { TelemetryService } from 'src/app/service/telemetry.service';
import { RealtimeVcuComponent } from './realtime-vcu/realtime-vcu.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccordionModule } from 'primeng/accordion';
import { SharedModule as PrimeNGSharedModule } from 'primeng/api';
import { SharedModule as AppSharedModule } from 'src/app/share/share.module';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CarouselModule } from 'primeng/carousel';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { ImageModule } from 'primeng/image';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputOtpModule } from 'primeng/inputotp';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { PasswordModule } from 'primeng/password';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { TranslocoRootModule } from 'src/app/transloco-root.module';
import { DashboardTemplateComponent } from '../dashboard/dashboard-template/dashboard-template.component';
import { CardModule } from '../card/card.module';
import { RegisterModule } from '../register/register.module';

@NgModule({
  declarations: [
    TelemetryMapComponent,
    TelemetryDashboardComponent,
    TelemetryRealtimeComponent,
    RealtimeVcuComponent
  ],
  imports: [
    CommonModule,
        ProgressSpinnerModule,
        CarouselModule,
        ImageModule,
        ButtonModule,
        FormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        InputTextModule,
        InputGroupModule,
        InputGroupAddonModule,
        PasswordModule,
        MessagesModule,
        MessageModule,
        ReactiveFormsModule,
        DropdownModule,
        CalendarModule,
        InputMaskModule,
        SelectButtonModule,
        TranslocoRootModule,
        HttpClientModule,
        CheckboxModule,
        InputOtpModule,
        DashboardTemplateComponent,
        TabMenuModule,
        InputSwitchModule,
        TooltipModule,
        ToastModule,
        ConfirmDialogModule,
        TableModule,
        PrimeNGSharedModule,
        AppSharedModule,
        DialogModule,
        DataViewModule,
        SkeletonModule,
        InputIconModule,
        IconFieldModule,
        AccordionModule,
        MultiSelectModule,
        CardModule,
        RegisterModule
  ],
  exports: [
    TelemetryMapComponent,
    TelemetryDashboardComponent,
    TelemetryRealtimeComponent,
    RealtimeVcuComponent
    
  ],
  providers: [
    SseService,
    TelemetryService
  ]
})
export class TelemetryModule { }
